function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.003,
  fill: "url(#SVGID_1_)",
  width: 2047.996,
  height: 2048
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "bars_etc"
}, /*#__PURE__*/React.createElement("rect", {
  x: 225.2,
  y: 88.026,
  opacity: 0.4,
  fill: "#EBECEC",
  width: 768.458,
  height: 222.477
}), /*#__PURE__*/React.createElement("rect", {
  x: 993.658,
  opacity: 0.5,
  fill: "#092542",
  width: 46.683,
  height: 2048
}), /*#__PURE__*/React.createElement("rect", {
  x: 946.977,
  y: 88.026,
  opacity: 0.2,
  fill: "#FFFFFF",
  width: 142.403,
  height: 222.477
}), /*#__PURE__*/React.createElement("rect", {
  x: 946.977,
  y: 358.46,
  opacity: 0.2,
  fill: "#FFFFFF",
  width: 142.403,
  height: 222.478
}), /*#__PURE__*/React.createElement("rect", {
  x: 946.977,
  y: 1440.198,
  opacity: 0.2,
  fill: "#FFFFFF",
  width: 142.403,
  height: 222.477
}), /*#__PURE__*/React.createElement("rect", {
  x: 946.977,
  y: 1710.636,
  opacity: 0.2,
  fill: "#FFFFFF",
  width: 142.403,
  height: 222.476
}), /*#__PURE__*/React.createElement("rect", {
  x: 1040.341,
  y: 88.026,
  opacity: 0.8,
  fill: "#EBECEC",
  width: 761.939,
  height: 222.477
}), /*#__PURE__*/React.createElement("rect", {
  x: 184.288,
  y: 358.46,
  opacity: 0.4,
  fill: "#EBECEC",
  width: 809.37,
  height: 222.478
}), /*#__PURE__*/React.createElement("rect", {
  x: 1040.341,
  y: 358.46,
  opacity: 0.8,
  fill: "#EBECEC",
  width: 809.371,
  height: 222.478
}), /*#__PURE__*/React.createElement("rect", {
  x: 184.288,
  y: 1440.198,
  opacity: 0.4,
  fill: "#EBECEC",
  width: 809.37,
  height: 222.477
}), /*#__PURE__*/React.createElement("rect", {
  x: 1040.341,
  y: 1440.198,
  opacity: 0.8,
  fill: "#EBECEC",
  width: 809.371,
  height: 222.477
}), /*#__PURE__*/React.createElement("rect", {
  x: 225.2,
  y: 1710.636,
  opacity: 0.4,
  fill: "#EBECEC",
  width: 768.458,
  height: 222.476
}), /*#__PURE__*/React.createElement("rect", {
  x: 1040.341,
  y: 1710.636,
  opacity: 0.8,
  fill: "#EBECEC",
  width: 761.939,
  height: 222.476
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Chord"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M1653.727,639.272v111.282l-310.654,642.175h-186.625l310.654-606.241v-2.318h-345.43V639.272H1653.727z"
})), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#FFFFFF",
  strokeWidth: 59,
  strokeMiterlimit: 10,
  points: "616.559,709.937 333.59,1364  970.271,1364  "
}));

var SvgIcon = function SvgIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "2048px",
    height: "2048px",
    viewBox: "0 0 2048 2048",
    enableBackground: "new 0 0 2048 2048",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "background_color"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 256,
    cy: 256.2881,
    r: 255.9988,
    gradientTransform: "matrix(4 0 0 4 9.813309e-004 -1.1641)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#16558E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1484,
    style: {
      stopColor: "#114473"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3121,
    style: {
      stopColor: "#0E365D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4926,
    style: {
      stopColor: "#0B2D4E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7008,
    style: {
      stopColor: "#092745"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#092542"
    }
  })), _ref2), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon.08334d5a.svg";
export { ForwardRef as ReactComponent };